// @ts-nocheck
import React from 'react';

const Checkbox = React.forwardRef(({ className = '', label, ...rest }, ref) => {
  const cb = (
    <input
      ref={ref}
      type="checkbox"
      className={['mov-cb', className].join(' ')}
      style={{
        appearance: 'none',
        WebkitAppearance: 'none',
        width: 16, height: 16,
        border: '1px solid var(--mov-line-strong)',
        borderRadius: 4,
        background: 'var(--mov-paper)',
        display: 'grid',
        placeItems: 'center',
        cursor: 'pointer',
        margin: 0,
        verticalAlign: 'middle',
        flexShrink: 0,
      }}
      {...rest}
    />
  );
  if (!label) return cb;
  return (
    <label className="inline-flex items-center gap-2 cursor-pointer text-[13px] text-mov-ink">
      {cb}
      <span>{label}</span>
    </label>
  );
});
Checkbox.displayName = 'Checkbox';

export default Checkbox;
